import { PopoverPanelProps } from "@headlessui/react"

import { classNames } from "../../../../lib/classNames"

export const basepopoverClassName = [
  "bg-elevation-surface-default",
  "border border-v2-border-default",
  "w-full",
  "rounded-lg",
  "shadow-surface",
  "overflow-hidden",
]

export const popoverClassName = classNames(...basepopoverClassName, "z-10")
export const modalPopoverClassName = classNames(
  ...basepopoverClassName,
  "z-[60]"
)

export const popoverRowClassName = classNames(
  "flex items-center rounded",
  "color-default text-body-lg",
  "bg-elevation-surface-default",
  "hover:bg-neutral-hovered",
  "active:bg-neutral-pressed",
  "px-2 min-h-8",
  "cursor-pointer"
)

export const popoverRowDisabledClassName = classNames(
  "!bg-gray-300 dark:!bg-gray-600",
  "!text-gray-500 dark:!text-gray-400",
  "!cursor-default",
  "!opacity-100",
  "hover:!bg-gray-300 dark:hover:!bg-gray-600"
)

export const popoverPanelAnchor: PopoverPanelProps["anchor"] = {
  to: "bottom start",
  gap: 4,
  padding: 4,
}

export const popoverPanelAnchorEnd: PopoverPanelProps["anchor"] = {
  to: "bottom end",
  gap: 4,
  padding: 4,
}
